















































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import DateTimeUtils from '@/lib/dateTimeUtils';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import CampaignBrowseContactsSearchCriteria from '@/components/CampaignContacts/CampaignBrowseContactsSearchCriteria.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import ContactProfileSummary from '@/components/Contacts/ContactProfileSummary.vue';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';
import CreateCampaignContactsRequest from '@/models/CampaignContacts/CreateCampaignContactsRequest';
//import CampaignBrowseContactsShortlist from '@/components/CampaignContacts/CampaignBrowseContactsShortlist.vue';
//import CampaignContactStatus from '@/components/CampaignContacts/Display/CampaignContactStatus.vue';

@Component({
  name: 'CampaignBrowseContacts',
  components: { CampaignBrowseContactsSearchCriteria, ContactProfileSummary } // CampaignBrowseContactsShortlist, ContactProfilePermSummary, CampaignContactStatus }
})
export default class extends GiganautVue {

	campaignStatusEnum = CampaignStatus;
	page = 1;
	perPage = 8;

	existingContact(id: string){
		for (let index = 0; index < CampaignDetailsModule.campaignContactsVM.campaignContacts.length; index++) {
			const campaignContact = CampaignDetailsModule.campaignContactsVM.campaignContacts[index];
			if (campaignContact.contactId === id) {
				return true;
			}
		}
		return false;
	}

	existingContactStatus(id: string){
		for (let index = 0; index < CampaignDetailsModule.campaignContactsVM.campaignContacts.length; index++) {
			const campaignContact = CampaignDetailsModule.campaignContactsVM.campaignContacts[index];
			if (campaignContact.contactId === id) {
				return campaignContact.status;
			}
		}
		return 0;
	}
	
	get isCampaignStatusDraft() {
		return CampaignDetailsModule.currentCampaign.status == CampaignStatus.Draft
	}

	get selectedContactId() {
		return CampaignDetailsModule.browseContactsVM.selectedContactId;
	}

	get selectedContactIds() {
		return CampaignDetailsModule.browseContactsVM.selectedContactIds;
	}

	set selectedContactId(id: string) {
		CampaignDetailsModule.browseContactsVM.selectedContactId = id;
	}

	get selectedContact() {
		return CampaignDetailsModule.browseContactsVM.selectedContact;
	}

	get currentCampaign() {
		return CampaignDetailsModule.currentCampaign;
	}
	
	get contactProfiles() {
		return CampaignDetailsModule.browseContactsVM.contactProfiles;
	}

	get pagedContactProfiles() {
		return this.contactProfiles.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	@Watch('selectedContactId', { immediate: true })
    async onSelectedContactIdChanged(val: string, oldVal: string) {
	   if (val !== '') {
		   await CampaignDetailsModule.updateSelectedBrowseContact(val);
	   }
	}
	
	async onPageChanged(input: number){
		CampaignDetailsModule.browseContactsVM.selectedContactId = (this.pagedContactProfiles[0].entity.id);
	}

	get loadingContacts() {
		return CampaignDetailsModule.loadingContacts;
	}

	async updateSelectedContactProfileIds(val: boolean, contactProfileId: string) {
    	if (val) {
			await CampaignDetailsModule.addBrowseSelectedContactId(contactProfileId)
		} else {
			await CampaignDetailsModule.removeBrowseSelectedContactId(contactProfileId)
		}
	}

	async addContactsToAudience() {
		if (CampaignDetailsModule.browseContactsVM.selectedContactIds.length > 0) {
			const request = new CreateCampaignContactsRequest();
			request.contactIds = CampaignDetailsModule.browseContactsVM.selectedContactIds;
			await CampaignDetailsModule.createCampaignContacts(request);
			await CampaignDetailsModule.getCampaignContacts();
		}
	}
}
